import cn from 'classnames';

import { ClipLoader } from '@wf/components';

import styles from './Loader.module.scss';

interface ILoader {
  className?: string;
}

function Loader({ className }: ILoader) {
  return (
    <div className={cn(styles.loader, className)}>
      <ClipLoader />
    </div>
  );
}

export default Loader;
